import { renderLocationSidebar } from './locationSidebar';

export const NEWS_LIST_TEMPLATE = `
<div class="flex h-screen overflow-hidden bg-background-light">
${renderLocationSidebar('news')}
<main class="ml-64 flex-1 overflow-hidden flex flex-col">
  <div class="flex-1 overflow-auto p-8">
    <div class="flex items-end justify-between mb-8">
      <div>
        <h1 class="text-3xl font-black text-slate-900 tracking-tight">News</h1>
        <p class="mt-1 text-sm text-slate-500">Manage platform announcements and editorial content</p>
      </div>
      <a href="/news/create" class="inline-flex items-center gap-2 h-11 px-6 rounded-lg bg-primary text-white font-bold shadow-sm shadow-primary/20 hover:bg-primary/90 transition-colors">
        <span class="material-symbols-outlined text-[20px]">add</span>
        <span>Create News</span>
      </a>
    </div>

    <section class="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-5 mb-8">
      <article class="bg-white border border-slate-200 rounded-xl p-5 shadow-sm text-center">
        <p class="text-sm text-slate-500 font-medium">Published</p>
        <p id="news-kpi-published" class="mt-1 text-3xl font-black text-slate-900">0</p>
      </article>
      <article class="bg-white border border-slate-200 rounded-xl p-5 shadow-sm text-center">
        <p class="text-sm text-slate-500 font-medium">Pending Review</p>
        <p id="news-kpi-pending" class="mt-1 text-3xl font-black text-slate-900">0</p>
      </article>
      <article class="bg-white border border-slate-200 rounded-xl p-5 shadow-sm text-center">
        <p class="text-sm text-slate-500 font-medium">Draft</p>
        <p id="news-kpi-draft" class="mt-1 text-3xl font-black text-slate-900">0</p>
      </article>
      <article class="bg-white border border-slate-200 rounded-xl p-5 shadow-sm text-center">
        <p class="text-sm text-slate-500 font-medium">Archived</p>
        <p id="news-kpi-archived" class="mt-1 text-3xl font-black text-slate-900">0</p>
      </article>
    </section>

    <section class="bg-white rounded-xl border border-slate-200 shadow-sm overflow-hidden">
      <div class="p-4 border-b border-slate-100 flex flex-wrap gap-3 items-center">
        <div class="relative flex-1 min-w-[260px]">
          <span class="material-symbols-outlined absolute left-3 top-1/2 -translate-y-1/2 text-slate-400">search</span>
          <input id="news-search" class="w-full h-10 pl-10 pr-4 rounded-lg bg-slate-50 border border-slate-200 text-sm placeholder:text-slate-400 focus:border-primary focus:ring-primary" placeholder="Search news by title, slug or content..." type="text"/>
        </div>
        <select id="news-filter-status" class="h-10 px-3 rounded-lg border border-slate-200 bg-slate-50 text-sm text-slate-700 focus:border-primary focus:ring-primary">
          <option value="">Status: All</option>
          <option value="published">Published</option>
          <option value="pending_review">Pending Review</option>
          <option value="draft">Draft</option>
          <option value="archived">Archived</option>
        </select>
        <select id="news-filter-category" class="h-10 px-3 rounded-lg border border-slate-200 bg-slate-50 text-sm text-slate-700 focus:border-primary focus:ring-primary">
          <option value="">Category: All</option>
        </select>
        <select id="news-filter-tag" class="h-10 px-3 rounded-lg border border-slate-200 bg-slate-50 text-sm text-slate-700 focus:border-primary focus:ring-primary">
          <option value="">Tag: All</option>
        </select>
        <button id="news-filter-featured" class="h-10 text-sm font-medium px-3 rounded-lg border border-slate-200 hover:bg-slate-50 flex items-center gap-1.5">
          <span class="material-symbols-outlined text-base">star</span> Featured
        </button>
        <button id="news-filter-pinned" class="h-10 text-sm font-medium px-3 rounded-lg border border-slate-200 hover:bg-slate-50 flex items-center gap-1.5">
          <span class="material-symbols-outlined text-base">push_pin</span> Pinned
        </button>
        <select id="news-ordering" class="h-10 px-3 rounded-lg border border-slate-200 bg-slate-50 text-sm text-slate-700 focus:border-primary focus:ring-primary">
          <option value="-published_at">Published At (Newest)</option>
          <option value="-view_count">View Count (High)</option>
          <option value="-rating_avg">Rating (High)</option>
          <option value="-updated_at">Updated At</option>
          <option value="title">Title (A-Z)</option>
        </select>
        <button id="news-reset-filters-btn" class="h-10 px-3 rounded-lg border border-slate-200 text-sm font-semibold text-primary hover:bg-primary/5" type="button">Reset</button>
      </div>

      <div class="overflow-x-auto bg-white">
    <table class="w-full text-left border-collapse min-w-[1400px]">
      <thead class="sticky top-0 bg-slate-50 z-10">
        <tr class="text-slate-500 text-[11px] font-bold uppercase tracking-wider border-b border-slate-200">
          <th class="px-6 py-4 w-20">ID</th>
          <th class="px-6 py-4 min-w-[280px]">Title & Slug</th>
          <th class="px-6 py-4">Category</th>
          <th class="px-6 py-4">Tags</th>
          <th class="px-6 py-4 text-center">Status</th>
          <th class="px-6 py-4 text-center">Featured</th>
          <th class="px-6 py-4 text-center">Pinned</th>
          <th class="px-6 py-4">Metrics</th>
          <th class="px-6 py-4">Dates</th>
          <th class="px-6 py-4 text-right">Actions</th>
        </tr>
      </thead>
      <tbody id="news-table-body" class="divide-y divide-slate-100">
        <tr><td class="px-6 py-8 text-sm text-slate-500" colspan="10">Loading news...</td></tr>
      </tbody>
    </table>
      </div>

      <footer class="bg-white border-t border-slate-200 px-6 py-4 flex items-center justify-between gap-4">
    <span id="news-meta" class="text-xs text-slate-500">Showing 0 results</span>
    <div class="flex items-center gap-2">
      <button id="news-prev-btn" class="px-3 py-1.5 rounded-lg border border-slate-200 text-slate-600 hover:bg-white text-sm disabled:opacity-50 disabled:cursor-not-allowed" type="button">Prev</button>
      <span id="news-page-indicator" class="text-xs font-semibold text-slate-500 min-w-[72px] text-center">Page 1</span>
      <button id="news-next-btn" class="px-3 py-1.5 rounded-lg border border-slate-200 text-slate-600 hover:bg-white text-sm disabled:opacity-50 disabled:cursor-not-allowed" type="button">Next</button>
    </div>
      </footer>
    </section>
  </div>
</main>
</div>

<div id="news-view-overlay" class="fixed inset-0 bg-slate-900/40 backdrop-blur-[1px] z-[70] hidden">
  <div id="news-view-backdrop" class="absolute inset-0"></div>
  <div class="absolute inset-y-0 right-0 w-full md:w-1/2 bg-white flex flex-col shadow-[-10px_0_30px_rgba(0,0,0,0.1)] rounded-l-xl">
    <div class="flex items-center justify-between px-6 py-4 border-b border-slate-100 shrink-0">
      <div class="flex items-center gap-4">
        <button id="news-view-close-btn" class="flex items-center justify-center size-10 rounded-lg hover:bg-slate-100 text-slate-500 transition-colors">
          <span class="material-symbols-outlined">close</span>
        </button>
        <div>
          <div class="flex items-center gap-2">
            <span id="news-view-status" class="px-2.5 py-0.5 rounded-full bg-emerald-100 text-emerald-700 text-[11px] font-bold uppercase tracking-wider">Published</span>
            <span id="news-view-id" class="text-xs text-slate-400">#ART-0</span>
          </div>
          <h1 id="news-view-title" class="text-xl font-bold text-slate-900 truncate max-w-[500px]">Article</h1>
        </div>
      </div>
      <a id="news-view-edit" href="/news/create" class="px-4 py-2 bg-primary text-white font-semibold text-sm rounded-lg flex items-center gap-2 shadow-sm hover:bg-blue-600 transition-all">
        <span class="material-symbols-outlined text-sm">edit</span>
        Edit Article
      </a>
    </div>

    <div class="flex-1 overflow-y-auto bg-slate-50/50">
      <div class="grid grid-cols-5 divide-x divide-slate-200 border-b border-slate-200 bg-white">
        <div class="p-4 text-center"><p class="text-[10px] uppercase font-bold text-slate-400 tracking-widest mb-1">Views</p><p id="news-view-views" class="text-lg font-bold text-slate-900">0</p></div>
        <div class="p-4 text-center"><p class="text-[10px] uppercase font-bold text-slate-400 tracking-widest mb-1">Rating</p><p id="news-view-rating" class="text-lg font-bold text-slate-900">0.00</p></div>
        <div class="p-4 text-center"><p class="text-[10px] uppercase font-bold text-slate-400 tracking-widest mb-1">Comments</p><p id="news-view-comments" class="text-lg font-bold text-slate-900">0</p></div>
        <div class="p-4 text-center"><p class="text-[10px] uppercase font-bold text-slate-400 tracking-widest mb-1">Bookmarks</p><p id="news-view-bookmarks" class="text-lg font-bold text-slate-900">0</p></div>
        <div class="p-4 text-center"><p class="text-[10px] uppercase font-bold text-slate-400 tracking-widest mb-1">Read Time</p><p id="news-view-read-time" class="text-lg font-bold text-slate-900">1m</p></div>
      </div>

      <div class="p-6 space-y-6">
        <div class="h-56 bg-slate-100 rounded-xl border border-slate-200 overflow-hidden">
          <img id="news-view-cover" class="w-full h-full object-cover" alt="News cover" src=""/>
        </div>
        <div id="news-view-gallery" class="grid grid-cols-4 gap-2"></div>

        <section class="bg-white p-5 rounded-xl border border-slate-200 shadow-sm space-y-4">
          <div>
            <label class="text-xs font-semibold text-slate-500 block mb-1 uppercase tracking-wider">Slug</label>
            <code id="news-view-slug" class="text-sm bg-slate-100 px-2 py-1 rounded text-primary break-all">-</code>
          </div>
          <div>
            <label class="text-xs font-semibold text-slate-500 block mb-1 uppercase tracking-wider">Excerpt</label>
            <p id="news-view-excerpt" class="text-sm text-slate-600 leading-relaxed italic">-</p>
          </div>
          <div>
            <label class="text-xs font-semibold text-slate-500 block mb-1 uppercase tracking-wider">Description</label>
            <p id="news-view-description" class="text-sm text-slate-700 whitespace-pre-wrap">-</p>
          </div>
          <div>
            <label class="text-xs font-semibold text-slate-500 block mb-1 uppercase tracking-wider">Content</label>
            <div id="news-view-content" class="text-sm text-slate-700 bg-slate-50 p-3 rounded-lg border border-slate-100 whitespace-pre-wrap">-</div>
          </div>
        </section>

        <div class="grid grid-cols-2 gap-4">
          <section class="bg-white p-5 rounded-xl border border-slate-200 shadow-sm space-y-3">
            <h3 class="font-bold text-slate-800">Classification</h3>
            <div><label class="text-xs font-semibold text-slate-500 block mb-1 uppercase tracking-wider">Category</label><p id="news-view-category" class="text-sm text-slate-900">-</p></div>
            <div><label class="text-xs font-semibold text-slate-500 block mb-1 uppercase tracking-wider">Tags</label><div id="news-view-tags" class="flex flex-wrap gap-2"></div></div>
          </section>
          <section class="bg-white p-5 rounded-xl border border-slate-200 shadow-sm space-y-3">
            <h3 class="font-bold text-slate-800">Source</h3>
            <div><label class="text-xs font-semibold text-slate-500 block mb-1 uppercase tracking-wider">Source Name</label><p id="news-view-source-name" class="text-sm text-slate-900">-</p></div>
            <div><label class="text-xs font-semibold text-slate-500 block mb-1 uppercase tracking-wider">Source URL</label><a id="news-view-source-url" href="#" target="_blank" rel="noreferrer" class="text-sm text-primary hover:underline break-all">-</a></div>
            <div><label class="text-xs font-semibold text-slate-500 block mb-1 uppercase tracking-wider">External URL</label><a id="news-view-external-url" href="#" target="_blank" rel="noreferrer" class="text-sm text-primary hover:underline break-all">-</a></div>
          </section>
        </div>

        <section class="bg-white p-5 rounded-xl border border-slate-200 shadow-sm space-y-3">
          <h3 class="font-bold text-slate-800">Admin & SEO</h3>
          <div class="grid grid-cols-2 gap-3 text-sm">
            <div><label class="text-xs font-semibold text-slate-500 block mb-1 uppercase tracking-wider">Published At</label><p id="news-view-published-at">-</p></div>
            <div><label class="text-xs font-semibold text-slate-500 block mb-1 uppercase tracking-wider">Updated At</label><p id="news-view-updated-at">-</p></div>
            <div><label class="text-xs font-semibold text-slate-500 block mb-1 uppercase tracking-wider">SEO Title</label><p id="news-view-seo-title">-</p></div>
            <div><label class="text-xs font-semibold text-slate-500 block mb-1 uppercase tracking-wider">SEO Description</label><p id="news-view-seo-description">-</p></div>
            <div class="col-span-2"><label class="text-xs font-semibold text-slate-500 block mb-1 uppercase tracking-wider">Review Comment</label><p id="news-view-review-comment">-</p></div>
          </div>
        </section>

        <section class="bg-white p-5 rounded-xl border border-slate-200 shadow-sm">
          <div class="mb-3 flex items-center justify-between">
            <h3 class="font-bold text-slate-800">Comments</h3>
            <p id="news-view-comments-count" class="text-xs text-slate-500">0</p>
          </div>
          <div id="news-view-comments-list" class="space-y-2"></div>
        </section>
      </div>
    </div>

    <div class="px-6 py-4 border-t border-slate-100 bg-white flex items-center justify-between shrink-0">
      <div class="flex gap-2">
        <button id="news-view-archive" class="flex items-center gap-2 px-4 py-2 text-slate-600 text-sm font-bold hover:bg-slate-100 rounded-lg transition-colors"><span class="material-symbols-outlined text-sm">archive</span>Archive</button>
        <button id="news-view-delete" class="flex items-center gap-2 px-4 py-2 text-rose-600 text-sm font-bold hover:bg-rose-50 rounded-lg transition-colors"><span class="material-symbols-outlined text-sm">delete</span>Delete</button>
      </div>
      <div class="flex gap-3">
        <button id="news-view-unpublish" class="px-4 py-2 border border-slate-200 text-slate-700 text-sm font-bold rounded-lg hover:bg-slate-50 transition-colors">Unpublish</button>
        <button id="news-view-publish" class="px-6 py-2 bg-primary text-white text-sm font-bold rounded-lg shadow-lg shadow-primary/25 hover:shadow-primary/40 transition-all">Publish</button>
      </div>
    </div>
  </div>
</div>
`;
